"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Number = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const maxNumberWidth = 90;
const StyledNumberContainer = styled_components_1.default.div `
  width: 100%;
  max-width: ${ui_common_components_1.utils.rem(maxNumberWidth)};
  position: relative;
`;
function Number({ initialValue, title, id, onUpdate }) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const handleResult = (0, react_1.useCallback)((newValue) => {
        setValue(newValue);
        onUpdate(newValue);
    }, [onUpdate]);
    (0, react_1.useEffect)(() => {
        setValue(initialValue);
    }, [initialValue]);
    return ((0, jsx_runtime_1.jsx)(StyledNumberContainer, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: id, name: title, value: value, onChange: (newValue) => handleResult(newValue), placeholder: initialValue === null || initialValue === void 0 ? void 0 : initialValue.toString(), type: "number", min: 0 }) }));
}
exports.Number = Number;
//# sourceMappingURL=Number.js.map